import { ProductCatalogApiClient } from '@fourthwall/services/dist/ProductCatalogApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useFavoritesCountQuery = createQueryHook(ProductCatalogApiClient.getFavoritesCount, {
  queryKey: ['favoritesCount'],
})
